import React, { useMemo } from 'react';
import { styled } from '@mui/material/styles';
import Stack from '@mui/material/Stack';
import { NavLink } from '../NavLink';
import { jsx as _jsx } from "react/jsx-runtime";
export function IngramSocials(props) {
  var socialMedias = props.socialMedias;
  var navItems = useMemo(function () {
    return socialMedias ? socialMedias.map(function (media) {
      return {
        content: /*#__PURE__*/_jsx("img", {
          alt: media.name,
          src: typeof media.iconImage === 'string' ? media.iconImage : ''
        }),
        key: media.name,
        label: media.name,
        url: media.url
      };
    }) : [];
  }, [socialMedias]);
  return /*#__PURE__*/_jsx(Stack, {
    direction: "row",
    marginTop: 4,
    spacing: 4,
    "data-element": "Stack",
    "data-component": "IngramSocials",
    "data-source-file": "IngramSocials.tsx",
    children: navItems.map(function (navItem) {
      return /*#__PURE__*/_jsx(StyledNavLink, {
        "data-testid": navItem.key,
        navItem: navItem
      }, navItem.key);
    })
  });
}
var StyledNavLink = styled(NavLink)(function (_ref) {
  var theme = _ref.theme;
  return {
    '@media only screen and (max-width: 1023.9px)': {
      margin: '0 13px 0 0 !important'
    },
    display: 'inline-block',
    height: 24
  };
});